import * as Sentry from '@sentry/react';

export function initSentry(context: 'taskpane' | 'webapp') {
  const dsn = process.env.SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    debug: true,
    environment: process.env.NODE_ENV || 'production',
    tracesSampleRate: 0.2,
    enableMetrics: true,
    enableLogs: true,
    initialScope: {
      tags: { addin_context: context },
    },
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
    ],
    denyUrls: [
      /\.hot-update\.js/,
      /webpack-internal/,
    ],
  });
}
